import { formatPhoneLabel } from "utils/PhoneFormat";
import { useData } from "data/data-provider";

function TermsandConditions({ data }: { data: any }) {
  const { ourCompany } = useData();
  return (
    <>
      <div className="mt-6 rounded-md border border-secondary-100 bg-bg-color p-4">
        <div className="mb-8">
          <h1 className="text-lg font-bold ">Terms & Conditions</h1>
          <p className="max-96 text-sm text-text-color">
            {`Please note the following booking Terms and Conditions apply to
         bookings placed directly on the ${data.company?.name} website.`}
          </p>
        </div>
        <div className="col-span-12 @container">
          <div className="flex flex-col gap-y-4">
            {data?.content?.terms_condition?.map((item: any, i: number) => {
              return (
                <div className="rounded-md border border-secondary-100" key={i}>
                  <div className="header rounded-md bg-bg-color px-5 py-3">
                    <h4 className="text-lg">
                      {i + 1}. {item?.title}
                    </h4>
                  </div>

                  <div className="header border-t border-secondary-100 p-5 w-full">
                    <div className="grid grid-cols-1 gap-3 rounded-md w-full">
                      <div
                        className="prose prose-sm ql-content break-words text-text-color"
                        style={{ maxWidth: "100%" }} // Manually remove the max width
                        dangerouslySetInnerHTML={{
                          __html: item?.content
                            ?.replace(
                              /\{\{phone\}\}/g,
                              formatPhoneLabel(ourCompany?.company?.phone_no),
                            )
                            ?.replace(
                              /\{\{email\}\}/g,
                              ourCompany?.company?.email,
                            )
                            ?.replace(
                              /\{\{address\}\}/g,
                              ourCompany?.company?.address,
                            )
                            ?.replace(
                              /\{\{deposit amount\}\}/g,
                              "$" + ourCompany?.default_deposit_amount,
                            ),
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default TermsandConditions;
